import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Modal, Form, Col } from '_zari/core'

import * as CajaChicaService from 'services/cajaChica.service'

const ProcesarDocumentosModal = ({ show, handleClose, idTituloViatico, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaProcesamiento, setFechaProcesamiento] = React.useState('')

  const clickProcesar = React.useCallback(() => {
    __zariContext.loader.open('Procesando documentos')
    CajaChicaService.procesarxIdTituloViatico(idTituloViatico)
      .then(() => {
        __zariContext.snack('success', 'Registros procesados correctamente.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idTituloViatico, reloadTable, handleClose])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Procesar documentos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label text='FECHA PROCESAMIENTO' htmlFor='procesamientoModal-fecha' md={4} alignRightAt='md' />
            <Col md={8}>
              <Form.InputDate
                id='procesamientoModal-fecha'
                name='procesamientoModal-fecha'
                value={fechaProcesamiento}
                onChange={e => setFechaProcesamiento(e.target.value)}
              />
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' tiny outline onClick={handleClose}>
          Cancelar
        </Button>
        <Button tiny onClick={clickProcesar}>
          Procesar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ProcesarDocumentosModal)
